export default __webpack_public_path__ + "assets/pdf/Joan_Ramos_Refusta_CV_2024.pdf";